import React from 'react';

export const htmlToStyle = (nodeName, node, currentStyle) => {
  const { textTransform } = node.style;
  if (nodeName === 'span' && textTransform === 'uppercase') {
    return currentStyle.add('UPPERCASE');
  }
  return currentStyle;
};
export const htmlToBlock = (nodeName, node, currentStyle) => {
  const {
    style: {
      pageBreakBefore,
      listStyleType,
      textAlign,
      padding,
      border,
      paddingLeft,
      margin
    },
    className
  } = node;
  if (nodeName === 'p' && textAlign === 'right' && className === 'mt0') {
    return { type: 'ALIGNRIGHTMT0' };
  } else if (nodeName === 'p' && textAlign === 'right' && className === 'mt2') {
    return { type: 'ALIGNRIGHTMT2' };
  } else if (
    nodeName === 'p' &&
    textAlign === 'center' &&
    className === 'mt0'
  ) {
    return { type: 'ALIGNCENTERMT0' };
  } else if (nodeName === 'p' && textAlign === 'right' && className === 'mb2') {
    return { type: 'ALIGNRIGHTMB2' };
  } else if (nodeName === 'p' && className === 'mt2 mb4') {
    return { type: 'PARAGRAPHMT2MB4' };
  } else if (nodeName === 'p' && className === 'mt0') {
    return { type: 'PARAGRAPHMT0' };
  } else if (nodeName === 'p' && className === 'mt2') {
    return { type: 'PARAGRAPHMT2' };
  } else if (nodeName === 'p' && className === 'mb0') {
    return { type: 'PARAGRAPHMB0' };
  } else if (nodeName === 'p' && className === 'pre') {
    return { type: 'PARAGRAPHPRE' };
  } else if (nodeName === 'p' && className === 'indentation1 mb1') {
    return { type: 'PARAGRAPHINDENTATION1PRE' };
  } else if (nodeName === 'p' && paddingLeft === '1cm') {
    return { type: 'PARAGRAPHPADDINGLEFT1' };
  } else if (nodeName === 'p' && className === 'indentation1') {
    return { type: 'PARAGRAPHINDENTATION1' };
  } else if (nodeName === 'div' && className === 'indentation1 pre') {
    return { type: 'DIVINDENTATION1PRE' };
  } else if (nodeName === 'div' && className === 'pre') {
    return { type: 'DIVPRE' };
  } else if (nodeName === 'div' && pageBreakBefore === 'always') {
    return { type: 'ALWAYSPAGEBREAKBEFORE' };
  } else if (
    (nodeName === 'div' && border === '1px solid black',
    padding === '0.25em' && margin === '0px auto')
  ) {
    return { type: 'DIVWITHBORDER' };
  } else if (nodeName === 'div' && className === 'indentation1') {
    return { type: 'DIVINDENTATION1' };
  } else if (nodeName === 'ol' && listStyleType === 'lower-alpha') {
    return { type: 'LISTSTYLELOWERALPHA' };
  } else if (nodeName === 'ul' && className === 'list-with-gaps') {
    return { type: 'LISTWITHGAPS' };
  } else if (nodeName === 'h1' && className === 'mb1') {
    return { type: 'H1MB1' };
  } else if (nodeName === 'h4' && className === 'mb1') {
    return { type: 'H4MB1' };
  } else if (nodeName === 'h5' && className === 'mb0') {
    return { type: 'H5MB0' };
  } else if (nodeName === 'h6' && className === 'mt0') {
    return { type: 'H6MT0' };
  } else if (nodeName === 'p' && textAlign === 'center') {
    return { type: 'ALIGNCENTER' };
  } else if (nodeName === 'p' && textAlign === 'right') {
    return { type: 'ALIGNRIGHT' };
  } else if (nodeName === 'p' && className === 'right-middle') {
    return { type: 'ALIGNMIDDLERIGHT' };
  } else if (nodeName === 'div' && className === 'right-middle') {
    return { type: 'DIVALIGNMIDDLERIGHT' };
  } else if (nodeName === 'div' && className === 'row') {
    return { type: 'DIVROW' };
  } else if (
    nodeName === 'p' &&
    padding === '0.25em' &&
    border === '1px solid black'
  ) {
    return { type: 'PARAGRAPHWITHBORDER' };
  } else if (
    nodeName === 'h1' &&
    textAlign === 'center' &&
    border === '1px solid black' &&
    padding === '0.25em'
  ) {
    return { type: 'HEADLINE1WITHBORDER' };
  } else if (
    nodeName === 'h4' &&
    textAlign === 'center' &&
    border === '1px solid black'
  ) {
    return { type: 'HEADLINE4WITHBORDER' };
  }
};

export const styleToHTML = style => {
  if (style === 'UPPERCASE') {
    return <span style={{ textTransform: 'uppercase' }} />;
  }
};

export const blockToHTML = (block, node) => {
  switch (block.type) {
    case 'ALIGNRIGHTMT0':
      return <p style={{ textAlign: 'right' }} className="mt0" />;
    case 'ALIGNRIGHTMT2':
      return <p style={{ textAlign: 'right' }} className="mt2" />;
    case 'ALIGNCENTERMT0':
      return <p style={{ textAlign: 'center' }} className="mt0" />;
    case 'ALIGNRIGHTMB2':
      return <p style={{ textAlign: 'right' }} className="mb2" />;
    case 'PARAGRAPHINDENTATION1PRE':
      return <p className="indentation1 mb1" />;
    case 'PARAGRAPHMT2MB4':
      return <p className="mt2 mb4" />;
    case 'PARAGRAPHMT0':
      return <p className="mt0" />;
    case 'PARAGRAPHMT2':
      return <p className="mt2" />;
    case 'PARAGRAPHMB0':
      return <p className="mb0" />;
    case 'PARAGRAPHPRE':
      return <p className="pre" />;
    case 'DIVPRE':
      return <div className="pre" />;
    case 'DIVINDENTATION1PRE':
      return <div className="indentation1 pre" />;
    case 'ALWAYSPAGEBREAKBEFORE':
      return <div style={{ pageBreakBefore: 'always' }} />;
    case 'DIVWITHBORDER':
      return (
        <div
          style={{
            border: 'solid 1px black',
            padding: '0.25em',
            margin: '0 auto'
          }}
        />
      );
    case 'LISTSTYLELOWERALPHA':
      return <ol style={{ listStyleType: 'lower-alpha' }} />;
    case 'LISTWITHGAPS':
      return <ul className="list-with-gaps" />;
    case 'H1MB1':
      return <h1 className="mb1" >
      </h1>;
    case 'H4MB1':
      return <h4 className="mb1" >
      </h4>;
    case 'H5MB0':
      return <h5 className="mb0" >
      </h5>;
    case 'H6MT0':
      return <h6 className="mt0" >
      </h6>;
    case 'ALIGNCENTER':
      return <p style={{ textAlign: 'center' }} />;
    case 'ALIGNRIGHT':
      return <p style={{ textAlign: 'right' }} />;
    case 'ALIGNMIDDLERIGHT':
      return <p className="right-middle" />;
    case 'PARAGRAPHINDENTATION1':
      return <p className="indentation1" />;
    case 'PARAGRAPHPADDINGLEFT1':
      return <p style={{ paddingLeft: '1cm' }} />;
    case 'DIVALIGNMIDDLERIGHT':
      return <div className="right-middle" />;
    case 'DIVROW':
      return <div className="row" />;
    case 'DIVINDENTATION1':
      return <div className="indentation1" />;
    case 'PARAGRAPHWITHBORDER':
      return <p style={{ border: '1px solid black', padding: '0.25em' }} />;
    case 'HEADLINE1WITHBORDER':
      return (
        <h1
          style={{
            textAlign: 'center',
            border: '1px solid black',
            padding: '0.25em'
          }}
          >
          </h1>
      );
    case 'HEADLINE4WITHBORDER':
      return (
        <h4
          style={{
            textAlign: 'center',
            border: '1px solid black',
            padding: '0.25em'
          }}
          >
          </h4>
      );
    default:
      return;
  }
};



// WEBPACK FOOTER //
// ./src/component/TaskCreator/Section/customStyles.js